import { render, staticRenderFns } from "./DataConfigsForm.vue?vue&type=template&id=9070bbc4&scoped=true&"
import script from "./DataConfigsForm.vue?vue&type=script&lang=js&"
export * from "./DataConfigsForm.vue?vue&type=script&lang=js&"
import style0 from "./DataConfigsForm.vue?vue&type=style&index=0&id=9070bbc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9070bbc4",
  null
  
)

export default component.exports